// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --ev-primary: #201157;
  --ev-primary-text: #ffffff;
  --ev-title: #201157;
  --ev-body: #555555;
  --ev-link: #201157;
  --ev-link-text: #ffffff;
  --ev-card-bg: #ffffff;
  --ev-bg: #f6f3ff;
  --ev-accent: #EB266A;
  --ev-radius: 16px;
  --ev-radius-sm: 12px;
  --ev-gradient: linear-gradient(180deg, transparent 0%, rgba(32, 17, 87, 0.6) 60%, var(--ev-primary) 100%);
  --ev-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  --ev-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.1);
  display: block;
  height: 100%;
  background: var(--ev-bg);
}

.ev-header ion-toolbar {
  --background: var(--ev-primary);
  --color: var(--ev-primary-text);
  --border-style: none;
}
.ev-header ion-buttons ion-menu-button, .ev-header ion-buttons back-button {
  --color: var(--ev-primary-text);
}

.ev-header--hero {
  position: absolute;
  z-index: 10;
  width: 100%;
}
.ev-header--hero ion-toolbar {
  --background: transparent;
  --color: #ffffff;
}
.ev-header--hero ion-buttons ion-menu-button, .ev-header--hero ion-buttons back-button {
  --color: #ffffff;
}

.section-title {
  font-size: 1rem;
  margin: 0 0 10px;
}

.ev-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.ev-loader__spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid color-mix(in srgb, var(--ev-primary) 20%, transparent);
  border-top-color: var(--ev-primary);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.ev-hero {
  position: relative;
  min-height: 380px;
  display: flex;
  align-items: flex-end;
  background-size: cover;
  background-position: center;
  background-color: var(--ev-primary);
  overflow: hidden;
}

.ev-hero--has-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--ev-gradient);
  z-index: 1;
}

.ev-hero__gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, color-mix(in srgb, var(--ev-primary) 30%, transparent) 0%, color-mix(in srgb, var(--ev-primary) 85%, transparent) 60%, var(--ev-primary) 100%);
  z-index: 1;
}

.ev-hero__content {
  position: relative;
  z-index: 2;
  padding: 80px 20px 32px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.ev-hero__badge-wrapper {
  margin-bottom: 16px;
}

.ev-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 50px;
  font-size: 13px;
  font-weight: var(--font-weight-semibold, 600);
  letter-spacing: 0.02em;
}

.ev-hero__badge--pre {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.ev-hero__badge--live {
  background: rgba(46, 204, 113, 0.2);
  color: #2ecc71;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.ev-hero__badge--post {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.ev-hero__pulse {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2ecc71;
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.4);
  }
}
.ev-hero__title {
  margin: 0 0 12px;
  font-size: 30px;
  font-weight: var(--font-weight-bold, 700);
  line-height: 1.2;
  color: #ffffff;
}

.ev-hero__date {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
}
.ev-hero__date ion-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.ev-countdown {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 20px;
}

.ev-countdown__unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 56px;
}

.ev-countdown__value {
  font-size: 32px;
  font-weight: var(--font-weight-bold, 700);
  line-height: 1;
  color: #ffffff;
  letter-spacing: 0.02em;
}

.ev-countdown__value--sec {
  color: #2ecc71;
}

.ev-countdown__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.ev-countdown__sep {
  font-size: 28px;
  font-weight: var(--font-weight-bold, 700);
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 16px;
}

.ev-chips {
  display: flex;
  gap: 10px;
  padding: 16px 16px 0;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  max-width: 800px;
  margin: 0 auto;
}
.ev-chips::-webkit-scrollbar {
  display: none;
}

.ev-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 50px;
  background: var(--ev-card-bg);
  box-shadow: var(--ev-shadow);
  font-size: 13px;
  color: var(--ev-body);
  white-space: nowrap;
  flex-shrink: 0;
  transition: box-shadow var(--transition-fast, 150ms ease), transform var(--transition-fast, 150ms ease);
}

.ev-chip--action {
  cursor: pointer;
}
.ev-chip--action:hover {
  box-shadow: var(--ev-shadow-hover);
  transform: translateY(-1px);
}

.ev-chip__icon {
  font-size: 16px;
  color: var(--ev-primary);
  flex-shrink: 0;
}

.ev-chip__label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ev-body {
  padding: 20px 16px 0;
  max-width: 800px;
  margin: 0 auto;
}

.ev-section {
  margin-bottom: 28px;
}

.ev-section {
  --section-title-color: var(--ev-title);
}

.ev-stats-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.ev-stat {
  flex: 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 20px 12px;
  background: var(--ev-card-bg);
  border-radius: var(--ev-radius-sm);
  box-shadow: var(--ev-shadow);
  text-align: center;
  transition: transform var(--transition-fast, 150ms ease), box-shadow var(--transition-fast, 150ms ease);
}

.ev-stat--cta {
  cursor: pointer;
}
.ev-stat--cta:hover {
  transform: translateY(-2px);
  box-shadow: var(--ev-shadow-hover);
}

.ev-stat__icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--ev-primary) 10%, transparent);
}

.ev-stat__icon-wrap--accent {
  background: color-mix(in srgb, var(--ev-accent) 12%, transparent);
}

.ev-stat__icon {
  font-size: 20px;
  color: var(--ev-primary);
}

.ev-stat__value {
  font-size: 26px;
  font-weight: var(--font-weight-bold, 700);
  color: var(--ev-title);
  line-height: 1;
}

.ev-stat__label {
  font-size: 12px;
  color: var(--ev-body);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ev-stat__label--cta {
  color: var(--ev-accent);
  font-weight: var(--font-weight-semibold, 600);
}

.ev-action-btn {
  flex: 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 12px;
  background: var(--ev-card-bg);
  border: none;
  border-radius: var(--ev-radius-sm);
  box-shadow: var(--ev-shadow);
  cursor: pointer;
  transition: transform var(--transition-fast, 150ms ease), box-shadow var(--transition-fast, 150ms ease);
}
.ev-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--ev-shadow-hover);
}

.ev-action-btn__icon {
  font-size: 24px;
  color: var(--ev-primary);
}

.ev-action-btn__label {
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  color: var(--ev-title);
}

.ev-card {
  padding: 20px;
  background: var(--ev-card-bg);
  border-radius: var(--ev-radius-sm);
  box-shadow: var(--ev-shadow);
}

.ev-card--row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.ev-card__icon-box {
  width: 48px;
  height: 48px;
  border-radius: var(--border-radius-md, 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--ev-primary) 10%, transparent);
  flex-shrink: 0;
}
.ev-card__icon-box ion-icon {
  font-size: 22px;
  color: var(--ev-primary);
}

.ev-card__icon-box--accent {
  background: color-mix(in srgb, var(--ev-accent) 10%, transparent);
}
.ev-card__icon-box--accent ion-icon {
  color: var(--ev-accent);
}

.ev-card__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.ev-card__primary {
  font-size: 15px;
  font-weight: var(--font-weight-semibold, 600);
  color: var(--ev-title);
}

.ev-card__secondary {
  font-size: 13px;
  color: var(--ev-body);
  line-height: 1.4;
}

.ev-card__link {
  font-size: 14px;
  color: var(--ev-link);
  text-decoration: none;
  font-weight: var(--font-weight-medium, 500);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.ev-card__link:hover {
  text-decoration: underline;
}

.ev-description {
  font-size: 15px;
  line-height: 1.6;
  color: var(--ev-body);
}
.ev-description p {
  margin: 0 0 12px;
}
.ev-description p:last-child {
  margin-bottom: 0;
}
.ev-description a {
  color: var(--ev-link);
  text-decoration: underline;
}

.ev-map {
  margin-top: 12px;
  border-radius: var(--ev-radius-sm);
  overflow: hidden;
  box-shadow: var(--ev-shadow);
}

.ev-footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px 20px;
  background: var(--ev-primary);
  color: var(--ev-primary-text);
  border: none;
  border-radius: var(--border-radius-button, 50px);
  font-size: 16px;
  font-weight: var(--font-weight-semibold, 600);
  cursor: pointer;
  transition: opacity var(--transition-fast, 150ms ease), transform var(--transition-fast, 150ms ease);
}
.ev-footer-btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}
.ev-footer-btn ion-icon:first-child {
  font-size: 20px;
}
.ev-footer-btn ion-icon:last-child {
  font-size: 18px;
  margin-left: auto;
}

.ev-sponsors-group {
  margin-bottom: 24px;
}
.ev-sponsors-group:last-child {
  margin-bottom: 0;
}

.ev-sponsors__category {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--ev-body);
  margin: 0 0 14px;
  opacity: 0.6;
}

.ev-sponsors__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 12px;
}

.ev-sponsor-card {
  background: var(--ev-card-bg);
  border-radius: var(--ev-radius-sm);
  padding: 18px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90px;
  box-shadow: var(--ev-shadow);
  transition: transform 200ms ease, box-shadow 200ms ease;
  cursor: default;
}
.ev-sponsor-card--clickable {
  cursor: pointer;
}
.ev-sponsor-card--clickable:hover {
  transform: translateY(-3px);
  box-shadow: var(--ev-shadow-hover);
}
.ev-sponsor-card__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.ev-sponsor-card__logo {
  max-width: 100%;
  max-height: 52px;
  object-fit: contain;
}
.ev-sponsor-card__name {
  font-size: 13px;
  font-weight: 500;
  color: var(--ev-title);
  text-align: center;
  line-height: 1.3;
}

.ev-spacer {
  height: 40px;
}

@media (min-width: 768px) {
  .ev-sponsors__grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
  }
  .ev-sponsor-card {
    padding: 22px 18px;
    min-height: 100px;
  }
  .ev-sponsor-card__logo {
    max-height: 60px;
  }
}
@media (min-width: 768px) {
  .ev-hero {
    min-height: 420px;
  }
  .ev-hero__content {
    padding: 100px 32px 40px;
  }
  .ev-hero__title {
    font-size: 38px;
  }
  .ev-countdown__value {
    font-size: 40px;
  }
  .ev-body {
    padding: 28px 24px 0;
  }
  .ev-stats-row {
    gap: 16px;
  }
}
@media (min-width: 1024px) {
  .ev-hero {
    min-height: 480px;
    border-radius: 0 0 24px 24px;
  }
  .ev-hero__content {
    padding: 120px 40px 48px;
  }
  .ev-hero__title {
    font-size: 44px;
  }
  .ev-body {
    padding: 32px 24px 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ev-hero__pulse {
    animation: none;
    opacity: 1;
  }
  .ev-countdown__value--sec {
    color: #2ecc71;
  }
  .ev-loader__spinner {
    animation: none;
    border-right-color: var(--ev-primary);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/event/event.page.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yGAAA;EACA,2CAAA;EACA,gDAAA;EAEA,cAAA;EACA,YAAA;EACA,wBAAA;AAAF;;AAIE;EACE,+BAAA;EACA,+BAAA;EACA,oBAAA;AADJ;AAKI;EACE,+BAAA;AAHN;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AALF;AAOE;EACE,yBAAA;EACA,gBAAA;AALJ;AASI;EACE,gBAAA;AAPN;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wEAAA;EACA,mCAAA;EACA,oCAAA;AATF;;AAYA;EACE;IAAK,yBAAA;EARL;AACF;AAUA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mCAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,UAAA;AARF;;AAWA;EACE,kBAAA;EACA,QAAA;EACA,kLAAA;EAMA,UAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,6CAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,qCAAA;EACA,WAAA;EACA,kCAAA;UAAA,0BAAA;AAbF;;AAgBA;EACE,mCAAA;EACA,cAAA;EACA,kCAAA;UAAA,0BAAA;AAbF;;AAgBA;EACE,qCAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;AAbF;;AAgBA;EACE;IAAW,UAAA;IAAY,mBAAA;EAXvB;EAYA;IAAM,YAAA;IAAc,qBAAA;EARpB;AACF;AAUA;EACE,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,+BAAA;AARF;AAUE;EACE,eAAA;EACA,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAYA;EACE,eAAA;EACA,yCAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;AATF;;AAYA;EACE,eAAA;EACA,yCAAA;EACA,+BAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;AATF;AAWE;EACE,aAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,uGAAA;AAVF;;AAaA;EACE,eAAA;AAVF;AAYE;EACE,kCAAA;EACA,2BAAA;AAVJ;;AAcA;EACE,eAAA;EACA,wBAAA;EACA,cAAA;AAXF;;AAcA;EACE,gBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,sCAAA;AAXF;;AAcA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAXF;;AAcA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;EACA,uGAAA;AAXF;;AAcA;EACE,eAAA;AAXF;AAaE;EACE,2BAAA;EACA,kCAAA;AAXJ;;AAeA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kEAAA;AAZF;;AAeA;EACE,iEAAA;AAZF;;AAeA;EACE,eAAA;EACA,wBAAA;AAZF;;AAeA;EACE,eAAA;EACA,yCAAA;EACA,sBAAA;EACA,cAAA;AAZF;;AAeA;EACE,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,6CAAA;AAZF;;AAeA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,uGAAA;AAZF;AAcE;EACE,2BAAA;EACA,kCAAA;AAZJ;;AAgBA;EACE,eAAA;EACA,wBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,2CAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,6BAAA;EACA,kCAAA;EACA,4BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kEAAA;EACA,cAAA;AAbF;AAeE;EACE,eAAA;EACA,wBAAA;AAbJ;;AAiBA;EACE,iEAAA;AAdF;AAgBE;EACE,uBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAfF;;AAkBA;EACE,eAAA;EACA,6CAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,2CAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAfF;AAiBE;EACE,0BAAA;AAfJ;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAhBF;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,gBAAA;AAhBN;AAoBE;EACE,qBAAA;EACA,0BAAA;AAlBJ;;AAsBA;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,4BAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,YAAA;EACA,gDAAA;EACA,eAAA;EACA,6CAAA;EACA,eAAA;EACA,oGAAA;AAnBF;AAqBE;EACE,aAAA;EACA,2BAAA;AAnBJ;AAsBE;EACE,eAAA;AApBJ;AAuBE;EACE,eAAA;EACA,iBAAA;AArBJ;;AAyBA;EACE,mBAAA;AAtBF;AAwBE;EACE,gBAAA;AAtBJ;;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAvBF;;AA0BA;EACE,6BAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;EACA,uDAAA;EACA,eAAA;AAvBF;AAyBE;EACE,eAAA;AAvBJ;AAyBI;EACE,2BAAA;EACA,kCAAA;AAvBN;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA3BJ;;AA+BA;EACE,YAAA;AA5BF;;AA+BA;EACE;IACE,4DAAA;IACA,SAAA;EA5BF;EA+BA;IACE,kBAAA;IACA,iBAAA;EA7BF;EA+BE;IACE,gBAAA;EA7BJ;AACF;AAiCA;EACE;IACE,iBAAA;EA/BF;EAkCA;IACE,wBAAA;EAhCF;EAmCA;IACE,eAAA;EAjCF;EAoCA;IACE,eAAA;EAlCF;EAqCA;IACE,oBAAA;EAnCF;EAsCA;IACE,SAAA;EApCF;AACF;AAuCA;EACE;IACE,iBAAA;IACA,4BAAA;EArCF;EAwCA;IACE,wBAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,oBAAA;EAxCF;AACF;AA2CA;EACE;IACE,eAAA;IACA,UAAA;EAzCF;EA4CA;IACE,cAAA;EA1CF;EA6CA;IACE,eAAA;IACA,qCAAA;EA3CF;AACF","sourcesContent":[":host {\n  --ev-primary: #201157;\n  --ev-primary-text: #ffffff;\n  --ev-title: #201157;\n  --ev-body: #555555;\n  --ev-link: #201157;\n  --ev-link-text: #ffffff;\n  --ev-card-bg: #ffffff;\n  --ev-bg: #f6f3ff;\n  --ev-accent: #EB266A;\n  --ev-radius: 16px;\n  --ev-radius-sm: 12px;\n  --ev-gradient: linear-gradient(180deg, transparent 0%, rgba(32, 17, 87, 0.6) 60%, var(--ev-primary) 100%);\n  --ev-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  --ev-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.1);\n\n  display: block;\n  height: 100%;\n  background: var(--ev-bg);\n}\n\n.ev-header {\n  ion-toolbar {\n    --background: var(--ev-primary);\n    --color: var(--ev-primary-text);\n    --border-style: none;\n  }\n\n  ion-buttons {\n    ion-menu-button, back-button {\n      --color: var(--ev-primary-text);\n    }\n  }\n}\n\n.ev-header--hero {\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n\n  ion-toolbar {\n    --background: transparent;\n    --color: #ffffff;\n  }\n\n  ion-buttons {\n    ion-menu-button, back-button {\n      --color: #ffffff;\n    }\n  }\n}\n\n.section-title {\n  font-size: 1rem;\n  margin: 0 0 10px;\n}\n\n.ev-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n}\n\n.ev-loader__spinner {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 4px solid color-mix(in srgb, var(--ev-primary) 20%, transparent);\n  border-top-color: var(--ev-primary);\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.ev-hero {\n  position: relative;\n  min-height: 380px;\n  display: flex;\n  align-items: flex-end;\n  background-size: cover;\n  background-position: center;\n  background-color: var(--ev-primary);\n  overflow: hidden;\n}\n\n.ev-hero--has-bg::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--ev-gradient);\n  z-index: 1;\n}\n\n.ev-hero__gradient {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    color-mix(in srgb, var(--ev-primary) 30%, transparent) 0%,\n    color-mix(in srgb, var(--ev-primary) 85%, transparent) 60%,\n    var(--ev-primary) 100%\n  );\n  z-index: 1;\n}\n\n.ev-hero__content {\n  position: relative;\n  z-index: 2;\n  padding: 80px 20px 32px;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.ev-hero__badge-wrapper {\n  margin-bottom: 16px;\n}\n\n.ev-hero__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 50px;\n  font-size: 13px;\n  font-weight: var(--font-weight-semibold, 600);\n  letter-spacing: 0.02em;\n}\n\n.ev-hero__badge--pre {\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  backdrop-filter: blur(8px);\n}\n\n.ev-hero__badge--live {\n  background: rgba(46, 204, 113, 0.2);\n  color: #2ecc71;\n  backdrop-filter: blur(8px);\n}\n\n.ev-hero__badge--post {\n  background: rgba(255, 255, 255, 0.12);\n  color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(8px);\n}\n\n.ev-hero__pulse {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #2ecc71;\n  animation: pulse-dot 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.6; transform: scale(1.4); }\n}\n\n.ev-hero__title {\n  margin: 0 0 12px;\n  font-size: 30px;\n  font-weight: var(--font-weight-bold, 700);\n  line-height: 1.2;\n  color: #ffffff;\n}\n\n.ev-hero__date {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.8);\n\n  ion-icon {\n    font-size: 18px;\n    flex-shrink: 0;\n  }\n}\n\n.ev-countdown {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 20px;\n}\n\n.ev-countdown__unit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 56px;\n}\n\n.ev-countdown__value {\n  font-size: 32px;\n  font-weight: var(--font-weight-bold, 700);\n  line-height: 1;\n  color: #ffffff;\n  letter-spacing: 0.02em;\n}\n\n.ev-countdown__value--sec {\n  color: #2ecc71;\n}\n\n.ev-countdown__label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n}\n\n.ev-countdown__sep {\n  font-size: 28px;\n  font-weight: var(--font-weight-bold, 700);\n  color: rgba(255, 255, 255, 0.4);\n  margin-bottom: 16px;\n}\n\n.ev-chips {\n  display: flex;\n  gap: 10px;\n  padding: 16px 16px 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  max-width: 800px;\n  margin: 0 auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.ev-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 50px;\n  background: var(--ev-card-bg);\n  box-shadow: var(--ev-shadow);\n  font-size: 13px;\n  color: var(--ev-body);\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: box-shadow var(--transition-fast, 150ms ease), transform var(--transition-fast, 150ms ease);\n}\n\n.ev-chip--action {\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: var(--ev-shadow-hover);\n    transform: translateY(-1px);\n  }\n}\n\n.ev-chip__icon {\n  font-size: 16px;\n  color: var(--ev-primary);\n  flex-shrink: 0;\n}\n\n.ev-chip__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ev-body {\n  padding: 20px 16px 0;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.ev-section {\n  margin-bottom: 28px;\n}\n\n.ev-section {\n  --section-title-color: var(--ev-title);\n}\n\n.ev-stats-row {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.ev-stat {\n  flex: 1;\n  min-width: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 20px 12px;\n  background: var(--ev-card-bg);\n  border-radius: var(--ev-radius-sm);\n  box-shadow: var(--ev-shadow);\n  text-align: center;\n  transition: transform var(--transition-fast, 150ms ease), box-shadow var(--transition-fast, 150ms ease);\n}\n\n.ev-stat--cta {\n  cursor: pointer;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--ev-shadow-hover);\n  }\n}\n\n.ev-stat__icon-wrap {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: color-mix(in srgb, var(--ev-primary) 10%, transparent);\n}\n\n.ev-stat__icon-wrap--accent {\n  background: color-mix(in srgb, var(--ev-accent) 12%, transparent);\n}\n\n.ev-stat__icon {\n  font-size: 20px;\n  color: var(--ev-primary);\n}\n\n.ev-stat__value {\n  font-size: 26px;\n  font-weight: var(--font-weight-bold, 700);\n  color: var(--ev-title);\n  line-height: 1;\n}\n\n.ev-stat__label {\n  font-size: 12px;\n  color: var(--ev-body);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ev-stat__label--cta {\n  color: var(--ev-accent);\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.ev-action-btn {\n  flex: 1;\n  min-width: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 20px 12px;\n  background: var(--ev-card-bg);\n  border: none;\n  border-radius: var(--ev-radius-sm);\n  box-shadow: var(--ev-shadow);\n  cursor: pointer;\n  transition: transform var(--transition-fast, 150ms ease), box-shadow var(--transition-fast, 150ms ease);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--ev-shadow-hover);\n  }\n}\n\n.ev-action-btn__icon {\n  font-size: 24px;\n  color: var(--ev-primary);\n}\n\n.ev-action-btn__label {\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  color: var(--ev-title);\n}\n\n.ev-card {\n  padding: 20px;\n  background: var(--ev-card-bg);\n  border-radius: var(--ev-radius-sm);\n  box-shadow: var(--ev-shadow);\n}\n\n.ev-card--row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.ev-card__icon-box {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--border-radius-md, 12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: color-mix(in srgb, var(--ev-primary) 10%, transparent);\n  flex-shrink: 0;\n\n  ion-icon {\n    font-size: 22px;\n    color: var(--ev-primary);\n  }\n}\n\n.ev-card__icon-box--accent {\n  background: color-mix(in srgb, var(--ev-accent) 10%, transparent);\n\n  ion-icon {\n    color: var(--ev-accent);\n  }\n}\n\n.ev-card__info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.ev-card__primary {\n  font-size: 15px;\n  font-weight: var(--font-weight-semibold, 600);\n  color: var(--ev-title);\n}\n\n.ev-card__secondary {\n  font-size: 13px;\n  color: var(--ev-body);\n  line-height: 1.4;\n}\n\n.ev-card__link {\n  font-size: 14px;\n  color: var(--ev-link);\n  text-decoration: none;\n  font-weight: var(--font-weight-medium, 500);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.ev-description {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--ev-body);\n\n  p {\n    margin: 0 0 12px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  a {\n    color: var(--ev-link);\n    text-decoration: underline;\n  }\n}\n\n.ev-map {\n  margin-top: 12px;\n  border-radius: var(--ev-radius-sm);\n  overflow: hidden;\n  box-shadow: var(--ev-shadow);\n}\n\n.ev-footer-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 16px 20px;\n  background: var(--ev-primary);\n  color: var(--ev-primary-text);\n  border: none;\n  border-radius: var(--border-radius-button, 50px);\n  font-size: 16px;\n  font-weight: var(--font-weight-semibold, 600);\n  cursor: pointer;\n  transition: opacity var(--transition-fast, 150ms ease), transform var(--transition-fast, 150ms ease);\n\n  &:hover {\n    opacity: 0.92;\n    transform: translateY(-1px);\n  }\n\n  ion-icon:first-child {\n    font-size: 20px;\n  }\n\n  ion-icon:last-child {\n    font-size: 18px;\n    margin-left: auto;\n  }\n}\n\n.ev-sponsors-group {\n  margin-bottom: 24px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.ev-sponsors__category {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  color: var(--ev-body);\n  margin: 0 0 14px;\n  opacity: 0.6;\n}\n\n.ev-sponsors__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 12px;\n}\n\n.ev-sponsor-card {\n  background: var(--ev-card-bg);\n  border-radius: var(--ev-radius-sm);\n  padding: 18px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 90px;\n  box-shadow: var(--ev-shadow);\n  transition: transform 200ms ease, box-shadow 200ms ease;\n  cursor: default;\n\n  &--clickable {\n    cursor: pointer;\n\n    &:hover {\n      transform: translateY(-3px);\n      box-shadow: var(--ev-shadow-hover);\n    }\n  }\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  &__logo {\n    max-width: 100%;\n    max-height: 52px;\n    object-fit: contain;\n  }\n\n  &__name {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ev-title);\n    text-align: center;\n    line-height: 1.3;\n  }\n}\n\n.ev-spacer {\n  height: 40px;\n}\n\n@media (min-width: 768px) {\n  .ev-sponsors__grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 16px;\n  }\n\n  .ev-sponsor-card {\n    padding: 22px 18px;\n    min-height: 100px;\n\n    &__logo {\n      max-height: 60px;\n    }\n  }\n}\n\n@media (min-width: 768px) {\n  .ev-hero {\n    min-height: 420px;\n  }\n\n  .ev-hero__content {\n    padding: 100px 32px 40px;\n  }\n\n  .ev-hero__title {\n    font-size: 38px;\n  }\n\n  .ev-countdown__value {\n    font-size: 40px;\n  }\n\n  .ev-body {\n    padding: 28px 24px 0;\n  }\n\n  .ev-stats-row {\n    gap: 16px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .ev-hero {\n    min-height: 480px;\n    border-radius: 0 0 24px 24px;\n  }\n\n  .ev-hero__content {\n    padding: 120px 40px 48px;\n  }\n\n  .ev-hero__title {\n    font-size: 44px;\n  }\n\n  .ev-body {\n    padding: 32px 24px 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ev-hero__pulse {\n    animation: none;\n    opacity: 1;\n  }\n\n  .ev-countdown__value--sec {\n    color: #2ecc71;\n  }\n\n  .ev-loader__spinner {\n    animation: none;\n    border-right-color: var(--ev-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
